import { alpha } from "@mui/material";
import { COLOR_WHITE } from "helpers/colors";
import { SPACING } from "helpers/spacings";
import React from "react";

export default function VideoThumbnailStatusLabel({ message, icon: IconComponent }) {
  const Icon = IconComponent;

  return (
    <div
      style={{
        color: alpha(COLOR_WHITE, 0.8),
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        fontSize: 14,
        margin: `0 ${SPACING}`,
        gap: 8,
        lineHeight: 1.4,
      }}
    >
      {Icon && <Icon style={{ fontSize: 24 }} />}
      <span>{message}</span>
    </div>
  );
}
